


export const getRange = (values)=>{
    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = max - min;
    return {min, max, range};
}

export const getXYRange = (xValues, yValues)=>{
    const { x } = getRange(xValues);
    const { y } = getRange(yValues);
    const { xMin, xMax, xRange } = {...x}
    const { yMin, yMax, yRange } = {...y};
    return {xMin, xMax, yMin, yMax, xRange, yRange};
}





